import type * as data from '../data/index.js';

export interface IReq_GetCombinedMetrics {
  method: 'getCombinedMetrics';
  request: {
    identity?: data.IIdentity;
    apiToken?: string;
    sections?: {
      server?: boolean;
      email?: boolean;
      dns?: boolean;
      security?: boolean;
      network?: boolean;
      radius?: boolean;
      vpn?: boolean;
    };
  };
  response: {
    metrics: {
      server?: data.IServerStats;
      email?: data.IEmailStats;
      dns?: data.IDnsStats;
      security?: data.ISecurityMetrics;
      network?: data.INetworkMetrics;
      radius?: data.IRadiusStats;
      vpn?: data.IVpnStats;
    };
    timestamp: number;
  };
}
